import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-terms-and-conditions-dialog',
  templateUrl: './terms-and-conditions-dialog.component.html',
  styleUrls: ['./terms-and-conditions-dialog.component.css']
})
export class TermsAndConditionsDialogComponent implements OnInit {

  constructor( public dialogRef: MatDialogRef<TermsAndConditionsDialogComponent>) { }

  ngOnInit() {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/terms-and-conditions-dialog/terms-and-conditions-dialog.component.ts